(function init() {
    const offer = window.tlFreeGiftOffer, widget = offer?.popupWidget;
    if (!offer || !widget) return setTimeout(init, 100);

    const consts = widget.constants,
          layoutDetail = consts.POPUP_LAYOUT.DETAILED_LIST,
          stateMet = consts.CONDITION_STATE.MET_BEFORE_CLAIM;

    widget.canClosePopup = function() {
        if (this.layout !== layoutDetail) return true;
        return !(offer.rules || []).some(r => r.show_on_pages && r.widget?.popup && !r.auto_add_gift &&
            offer.getRuleState(r.id).conditionState === stateMet);
    };

    const origToggle = widget.handleToggle;
    widget.handleToggle = function(e) {
        if (
            e &&
            !e.target.classList.contains("salepify-popup-wrapper") &&
            !e.target.closest(".salepify-popup-header__close-button")
        ) return;

        if (
            e?.target?.classList?.contains("salepify-popup-wrapper") &&
            !this.modalEle.classList.contains("salepify-popup--hide") &&
            !this.canClosePopup()
        ) return;

        origToggle.call(this, e);
    };

    const origUpdate = widget.updateOffer;
    if (origUpdate) {
        widget.updateOffer = async function(rule) {
            await origUpdate.call(this, rule);
            const btn = this.modalEle.querySelector(".salepify-popup-header__close-button");
            if (btn) btn.style.display = "";
        };
    }

    const origShow = offer.showPopupOffer;
    offer.showPopupOffer = function(eligibleOtherRules) {
        const eligible = (eligibleOtherRules || []).filter(({rule}) => rule.widget ? rule.widget.popup : true);
        const hasUnclaimed = eligible.some(({rule}) => !rule.auto_add_gift &&
            this.getRuleState(rule.id).conditionState === stateMet);

        if (this.popupWidget.layout === layoutDetail && hasUnclaimed) {
            this.popupWidget.showModal();
        } else {
            origShow.call(this, eligibleOtherRules);
        }
    };
})();